<template>
    <div>
      <div class="mb-30">
          <div class="text-right">
              <Button type="primary" size="mini" @click="updateCertification">{{$t('PROFILE_SAVE')}}</Button>
            </div>
          <h4 class="card-list-title mb-15 text-lowercase text-md position-relative">{{$t('TRANSPORTER_PROFILE_FSSAI')}}
          </h4>
          <Row type="flex" align="middle">
            <Form :inline="true" class="form-default full-width mb-20 mr-10">
            <Col :span="6">
                <FormItem :label="$t('TRANSPORTER_PROFILE_CERTIFICATE_NUMBER')">
                  <Input :placeholder="$t('TRANSPORTER_PROFILE_CERTIFICATE_NUMBER')"
                  type="text" v-model="certificationData.fssai.number"></Input>
                </FormItem>
            </Col>
            <Col :span="6">
              <FormItem :label="$t('TRANSPORTER_PROFILE_VALID_TILL')" class="f-left">
              <DatePicker
                  v-model="certificationData.fssai.expiry_date"
                  type="date"
                  format="dd-MM-yyyy"
                  :placeholder="$t('TRANSPORTER_PROFILE_PICK_DATE')"
                  size="small" />
              </FormItem>
            </Col>
            <Col :span="8" :offset="4">
                <div class="wp-100 px-10 py-15" style="border: 1px solid #E8E8E8;">
                <Row type="flex" align="middle">
                    <Col :span="3">
                      <div class="el-upload-list__item-slot">
                        <img v-if="!getFileType('fssai') && certificationData.fssai.attachment_id === ''"
                            class="el-upload-list__item-thumbnail"
                            width="30"
                            height="30"
                            :src="noFile"
                            alt=""
                        />
                        <span v-else-if="getFileType('fssai') === 'image'">
                          <ElImage
                            style="width: 30px; height: 30px"
                            :src="getImage('fssai')"
                            :preview-src-list="getPreviewImage('fssai')"></ElImage>
                        </span>
                        <span v-else-if="getFileType('fssai') === 'pdf'">
                          <svgicon  name="icon-pdf" width="25" height="25" :original="true" />
                        </span>
                      </div>
                    </Col>
                    <Col
                    :span="15"
                    class="text-bold text-capitalize pl-10">
                    {{getFileType('fssai', false) ? getFileType('fssai', false) : 'No File Uploaded' }}
                      <svgicon @click="fileDownload('fssai')" v-if="getFileType('fssai') === 'pdf'" name="icon-download-xl" width="18" height="18" :original="true" class="pl-5 pointer" />
                    </Col>
                    <Col :span="6">
                    <Button type="text" size="mini" class="ml-auto default-cursor">
                        <label>
                          <input class="upload-material" type="file" id="file" ref="fssai_file"
                          v-on:change="handleFileUpload('fssai','fssai_file')"/>
                          <span class="text-blue pointer">{{$t('ATTACHMENT_UPLOAD')}}</span>
                        </label>
                      </Button>
                    </Col>
                </Row>
                </div>
            </Col>
            </Form>
          </Row>
      </div>
      <div class="mb-30">
          <h4 class="card-list-title mb-15 text-lowercase text-md position-relative">{{$t('TRANSPORTER_PROFILE_TDS')}}
          </h4>
          <Row type="flex" align="middle">
            <Form :inline="true" class="form-default full-width mb-20 mr-10">
            <Col :span="6">
              <FormItem :label="$t('TRANSPORTER_PROFILE_CERTIFICATE_NUMBER')">
                <Input :placeholder="$t('TRANSPORTER_PROFILE_CERTIFICATE_NUMBER')"
                type="text" v-model="certificationData.tds.number"></Input>
              </FormItem>
            </Col>
            <Col :span="6">
              <FormItem :label="$t('TRANSPORTER_PROFILE_VALID_TILL')">
                <DatePicker
                  v-model="certificationData.tds.expiry_date"
                  type="date"
                  :placeholder="$t('TRANSPORTER_PROFILE_PICK_DATE')"
                  format="dd-MM-yyyy"
                  size="small" />
              </FormItem>
            </Col>
            <Col :span="8" :offset="4">
              <div class="wp-100 px-10 py-15" style="border: 1px solid #E8E8E8;">
                <Row type="flex" align="middle">
                    <Col :span="3">
                      <div class="el-upload-list__item-slot">
                        <img v-if="!getFileType('tds') && certificationData.tds.attachment_id === ''"
                            class="el-upload-list__item-thumbnail"
                            width="30"
                            height="30"
                            :src="noFile"
                            alt=""
                        />
                        <span v-else-if="getFileType('tds') === 'image'">
                          <ElImage
                            style="width: 30px; height: 30px"
                            :src="getImage('tds')"
                            :preview-src-list="getPreviewImage('tds')"></ElImage>
                        </span>
                        <span v-else-if="getFileType('tds') === 'pdf'">
                          <svgicon  name="icon-pdf" width="25" height="25" :original="true" />
                        </span>
                      </div>
                    </Col>
                    <Col
                    :span="15"
                    class="text-bold text-capitalize pl-10">
                    {{getFileType('tds', false) ? getFileType('tds', false) : 'No File Uploaded' }}
                      <svgicon @click="fileDownload('tds')" v-if="getFileType('tds') === 'pdf'" name="icon-download-xl" width="18" height="18" :original="true" class="pl-5 pointer" />
                    </Col>
                    <Col :span="6">
                      <Button type="text" size="mini" class="ml-auto default-cursor">
                        <label>
                          <input class="upload-material" type="file" id="file" ref="tds_file"
                          v-on:change="handleFileUpload('tds','tds_file')"/>
                          <span class="text-blue pointer">{{$t('ATTACHMENT_UPLOAD')}}</span>
                        </label>
                      </Button>
                    </Col>
                </Row>
              </div>
            </Col>
            </Form>
          </Row>
      </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import downloadFile from '@common/utils/downloadFile';
import noFile from '@common/asset/svg/no-file-uploaded.png';

export default {
  name: 'Certifications',
  data() {
    return {
      noFile,
      certificationData: {},
      fileTypes: ['image/jpg', 'image/jpeg', 'application/pdf'],
    };
  },
  computed: {
    ...mapGetters({
      isUploading: 'profile/isUploading',
    }),
    getFileType() {
      return (type, check = true) => {
        if (this.certificationData[type] && this.certificationData[type].attachment_url) {
          const url = this.certificationData[type].attachment_url;
          if (url === '') {
            return false;
          }
          const fileName = url.split('/').pop().split('#')[0].split('?')[0];
          if (fileName.indexOf('.jpg') > -1 || fileName.indexOf('.jpeg') > -1 || fileName.indexOf('.svg') > -1 || fileName.indexOf('.png') > -1) {
            return check ? 'image' : 'Image attached';
          } else if (fileName.indexOf('.pdf') > -1) {
            return check ? 'pdf' : 'PDF attached';
          }
        }
        return false;
      };
    },
    getImage() {
      return (type) => {
        if (this.certificationData[type] && this.certificationData[type].attachment_url) {
          return this.certificationData[type].attachment_url;
        }
        return '';
      };
    },
    getPreviewImage() {
      return (type) => {
        if (this.certificationData[type] && this.certificationData[type].attachment_url) {
          return [this.certificationData[type].attachment_url];
        }
        return [];
      };
    },
  },
  props: {
    certificates: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    this.initializeData();
  },
  methods: {
    /**
     * Handler to set intial data onload
     */
    initializeData() {
      this.certificationData = this.certificates ? cloneDeep(this.certificates) : {};
    },
    /**
     * Emit handler to trigger update flow
     */
    updateCertification() {
      if (!this.certificationData.fssai.expiry_date) {
        this.certificationData.fssai.expiry_date = '';
      }
      if (!this.certificationData.tds.expiry_date) {
        this.certificationData.tds.expiry_date = '';
      }
      this.$emit('update-certification', this.certificationData);
    },
    /**
     * Upload file handler
     */
    handleFileUpload(type, inputRef) {
      const file = this.$refs[inputRef].files[0];
      const validAttachment = this.getAttachmentType(file);
      if (validAttachment) {
        this.$emit('upload-certification', { type, attachment_url: file });
      } else {
        this.$errorMessage({ message: this.$getErr('INVALID_FORMAT') });
      }
      // Reset the uploaded file value
      const input = this.$refs[inputRef];
      input.type = 'text';
      input.type = 'file';
    },
    /**
     * Handler to update attachment info
     */
    updateAttachmentUrl(type, data) {
      this.certificationData[type].attachment_id = data.id;
      this.certificationData[type].attachment_url = data.attachment_url;
    },
    /**
     * Download handler
     */
    fileDownload(type) {
      downloadFile(document, this.certificationData[type].attachment_url, `${type}-certificate.pdf`);
    },
    /**
     * To check if the attached file supports the file format
     */
    getAttachmentType(file) {
      if (file.type && this.fileTypes.includes(file.type)) {
        return true;
      }
      return false;
    },
  },
};
</script>
